import { reduxForm } from 'redux-form'

import { createValidator, required } from 'lib/form-validation'

import {
  getRegistryId,
  getSearchLevel,
  getShippingAddress,
  getVisitorPassword,
} from 'registry/reducers'
import RegistryVisibility from './registry-visibility'

const RegistryVisibilityValidator = createValidator({
  'registry.visitorPassword': [required],
})

const validate = (data) => {
  if (data.passwordAccess) {
    return RegistryVisibilityValidator(data)
  }
  return {}
}

export default reduxForm(
  {
    form: 'RegistryVisibilityForm',
    fields: [
      'passwordAccess',
      'registry.id',
      'registry.searchLevel',
      'registry.visitorPassword',
      'registry.isShippingAddressPrivate',
    ],
    validate,
  },
  (state, ownProps) => {
    const address = ownProps.address || getShippingAddress(state) || {}

    return {
      initialValues: {
        registry: {
          id: getRegistryId(state),
          searchLevel: getSearchLevel(state),
          visitorPassword: getVisitorPassword(state),
          isShippingAddressPrivate: address.privateAddress,
        },
        passwordAccess: !!getVisitorPassword(state),
      },
      layout: ownProps.layout,
    }
  }
)(RegistryVisibility)
